import { Button, ButtonProps } from '@mui/material';
import { MouseEvent, useEffect } from 'react';
import { useCountdown } from 'usehooks-ts';

import { getDataTestId } from '@/utils/browser';

import { CountDownSeconds, CountDownText } from './CountDownButton.styled';

type CountDownButtonProps = {
  buttonText: string;
  countDownText: string;
  countDownOptions?: {
    countStart?: number;
    intervalMs?: number;
  };
  showResendButton?: boolean;
} & ButtonProps;

export function CountDownButton({
  buttonText,
  countDownText,
  countDownOptions = {},
  onClick,
  showResendButton = true,
  ...props
}: CountDownButtonProps) {
  const [countToResend, { startCountdown, resetCountdown }] = useCountdown({
    countStart: 60,
    intervalMs: 1000,
    ...countDownOptions,
  });
  useEffect(() => {
    startCountdown();
  }, [startCountdown]);

  const onReset = (e: MouseEvent<HTMLButtonElement>) => {
    resetCountdown();
    startCountdown();
    onClick?.(e);
  };

  if (countToResend === 0 && showResendButton) {
    return (
      <Button
        {...getDataTestId(`button-${buttonText}`)}
        onClick={onReset}
        variant="outlined"
        fullWidth
        {...props}
      >
        {buttonText}
      </Button>
    );
  }

  return (
    <CountDownText>
      {countDownText}
      <CountDownSeconds>{countToResend}</CountDownSeconds>
    </CountDownText>
  );
}
